
import { keys, mapValues } from 'lodash';
import { connect } from 'react-redux';
import {
  setArtifactsMetricsInfo,
  setCaseMetricsInfo,
  setEngineMetricsInfo,
  setMetricsByDateInfo,
  setPerformanceMetricsInfo,
  setJobBenchmarkMetricsInfo,
  modal as modalActions,
  telemetry as telemetryActions
} from './../actions';
import MetricsSelectorComponent from './../Components/MetricsSelectorComponent';

import { pageTypes } from './../helpers';
import {
  getCaseMetricsImages,
  getDispatchersByDispatcherJobName,
  getMetricsByDateInfo,
  getMetricTestNodes,
  getMetricsPageDropdownFirstSelected,
  metricsJobsByCaseActions,
  metricPageReducer,
  scenarioReducer
} from './../reducers';
import {
  metrics as metricSelectors,
  metricsPage as metricPageSelectors
} from '../selectors';

export const mapStateToProps = (state) => {
  const metricsInfo = metricPageReducer.getMetricsPageInfo(state);

  const scenariosByName = scenarioReducer
    .getDispatchedScenariosByName(state, metricsInfo.dispatcherId);
  const analyzedStatusesByName = mapValues(scenariosByName, (scenario) => {
    const analyzedStatus = metricPageSelectors
      .getAnalyzedMetricRunnerStatus(state, scenario.runner);
    return analyzedStatus.status;
  });
  const props = {
    metricsByDateInfo: getMetricsByDateInfo(state),
    metricsInfo: metricsInfo,
    availableNodes: getMetricTestNodes(state),
    availableImages: getCaseMetricsImages(state),
    availableCaseActions: keys(metricsJobsByCaseActions(state)),
    availableCaseActionsByDispatcher:
      keys(metricSelectors.caseActionsScenarioStatusByDispatcher(state)),
    availableDispatchers: getDispatchersByDispatcherJobName(state),
    dropdownPairFirstSelected: getMetricsPageDropdownFirstSelected(state),
    analyzedStatusesByName
  };
  return props;
};

export const mapDispatchToProps = (dispatch, ownProps) => ({
  onDateSelected: () => {
    dispatch(modalActions.showSetMetricsByDateModal(true));
  },
  onSelectorChange: info => {
    dispatch(setMetricsByDateInfo(info));
    switch (ownProps.pageType) {
      case pageTypes.CASEMETRICS:
        dispatch(setCaseMetricsInfo(info));
        break;
      case pageTypes.PERFORMANCEMETRICS:
        dispatch(setPerformanceMetricsInfo(info));
        break;
      case pageTypes.JOBBENCHMARK:
        dispatch(setJobBenchmarkMetricsInfo(info));
        break;
      case pageTypes.ARTIFACTSMETRICS:
        dispatch(setArtifactsMetricsInfo(info));
        break;
      case pageTypes.ENGINEMETRICS:
        dispatch(setEngineMetricsInfo(info));
        break;
      default:
    }
  },
  onControlUse: controlName => {
    dispatch(telemetryActions.addControlTelemetry(controlName));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricsSelectorComponent);


// WEBPACK FOOTER //
// src/Containers/MetricsSelectorContainer.jsx